// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3LiWP","right":"styles_right__35s_a"};